import { render, staticRenderFns } from "./EventAdminEdit.vue?vue&type=template&id=74fdd181&scoped=true"
import script from "./EventAdminEdit.vue?vue&type=script&lang=js"
export * from "./EventAdminEdit.vue?vue&type=script&lang=js"
import style0 from "./EventAdminEdit.vue?vue&type=style&index=0&id=74fdd181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fdd181",
  null
  
)

export default component.exports